<template>
    <return-button class="return-button" />
    <div class="main-container">
        <div class="title-header">
            <h1 class="title">Información del Doctor</h1>
        </div>

        <div class="content-container">
            <!-- Fila de nombres -->
            <div>
                <v-row class="name-row">
                    <v-col cols="12" md="3">
                        <span class="label">Nombre:</span>
                        <span class="value">{{ nombre }}</span>
                    </v-col>
                    <v-col cols="12" md="4">
                        <span class="label">Primer apellido:</span>
                        <span class="value">{{ primerApellido }}</span>
                    </v-col>
                    <v-col cols="12" md="4">
                        <span class="label">Segundo apellido:</span>
                        <span class="value">{{ segundoApellido }}</span>
                    </v-col>
                </v-row>
            </div>
            <!-- <div class="name-row">
                <div class="data-item">
                    <span class="label">Nombre:</span>
                    <span class="value">{{ nombre }}</span>
                </div>
                <div class="data-item">
                    <span class="label">Primer apellido:</span>
                    <span class="value">{{ primerApellido }}</span>
                </div>
                <div class="data-item">
                    <span class="label">Segundo apellido:</span>
                    <span class="value">{{ segundoApellido }}</span>
                </div>
            </div> -->

            <div class="cedulas-container">
                <div v-for="(cedula, index) in cedulas" :key="index" class="cedula-card">
                    <div class="cedula-info">
                        <span class="cedula-label">Cedula {{ cedula.type }}:</span>
                        <span class="cedula-value">{{ cedula.professionalLicense }}</span>
                    </div>
                    <div class="cedula-info">
                        <span class="cedula-label">Institución:</span>
                        <span class="cedula-value">{{ cedula.issuer.reference }}</span>
                    </div>
                    <div class="cedula-info">
                        <span class="cedula-label">Numero de cedula:</span>
                        <span class="cedula-value">{{ cedula.identifier }}</span>
                    </div>
                </div>
            </div>

            <!-- Información profesional -->
            <div class="">
                <!-- No sabemos por que, pero este componente necesita de las especialidades, no agrega contenido, pero no sirve si se quita. NO LO QUITES!!!! -->
                    {{
                            especialidades.length > 0
                                ? ' / ' + especialidades.join(' / ')
                                : ''
                        }}
            </div>
        </div>
    </div>
</template>

<script>
import { getPractitioner } from '@/api/practicante';
import { getAllLocationsByDistance, getAllLocationsByDistanceFromCoordinates } from '@/api/location';
import returnButton from '@/components/global/return-button.vue';

export default {
    data() {
        return {
            nombre: '',
            primerApellido: '',
            segundoApellido: '',
            titulo: '',
            especialidades: [],
            universidad: '',
            cedula: '',
            cedulas: [],
            diplomado: '',
            cedulaEstatal: '',
            cedulaFederal: '',
            registro: '',
        };
    },
    computed: {},
    methods: {
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.userLocation = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        };
                    },
                    (error) => {
                        console.error('Error al obtener la ubicación:', error);
                    },
                );
            }
        },
        fetchLocations() {
            if (this.userLocation) {
                getAllLocationsByDistanceFromCoordinates(
                    this.userLocation.latitude,
                    this.userLocation.longitude,
                )
                    .then((response) => {
                        this.locations = response;
                    })
                    .catch((error) => {
                        console.error(
                            'Error al obtener las localizaciones: ',
                            error,
                        );
                    });
                return;
            }
            if (this.location) {
                getAllLocationsByDistance(this.location)
                    .then((response) => {
                        this.locations = response;
                    })
                    .catch((error) => {
                        console.error(
                            'Error al obtener las localizaciones: ',
                            error,
                        );
                    });
            }
        },
        fetchPractitioner() {
            let id_med = localStorage.getItem('id-user');

            if (!id_med) {
                console.error(
                    'ID del practicante no encontrado en localStorage',
                );
                return;
            }
            getPractitioner(id_med)
                .then((response) => {
                    this.nombre = response.name?.[0] || '';
                    this.primerApellido = response.lastname?.[0] || '';
                    this.segundoApellido = response.lastname?.[1] || '';
                   // console.log(response);

                    this.titulo =
                        response.qualification?.[0]?.cedulaProfesional || '';
                    this.especialidades = response.qualification
                        ? response.qualification
                              .slice(1)
                              .map((qual) => qual.cedulaProfesional)
                              .filter(Boolean)
                        : [];
                    this.universidad =
                        response.qualification?.[0]?.issuer?.reference || '';
                    this.cedula = response.qualification?.[0]?.identifier || '';
                    this.diplomado = response.aditional_data?.[0] || '';
                    this.cedulas = response.qualification || [];

                    this.registro = response.registry || '';
                    this.itemsPractitioners = [
                        { indicador: 'Nombre', valor: response.name?.[0] },
                        { indicador: 'Apellido', valor: response.lastname?.[0] },
                        {
                            indicador: 'Título',
                            valor: response.qualification?.[0]?.professionalLicense,
                        },
                        {
                            indicador: 'Cédula',
                            valor: response.qualification?.[0]?.identifier,
                        },
                    ];
                    this.prefix = response.prefix;
                    this.practitionerChecked = response.internal_practitioner;
                    this.location = response.location;
                    this.postalCode = response.postal_code;
                    this.aditionalDataOne = response.aditional_data?.[0];
                    this.aditionalDataTwo = response.aditional_data?.[1];
                    if (response.telecom && response.telecom.length > 0) {
                        this.contacts = response.telecom;
                    } else {
                        this.contacts = [];
                    }
                    this.fetchLocations();
                })
                .catch((error) => {
                    console.error(
                        'Error al obtener los datos del médico: ',
                        error,
                    );
                });
        },
    },
    mounted() {
        this.idPractitioner = this.$route.params.id;
        //this.getUserLocation();
        this.fetchPractitioner();
    },
    components: {
        'return-button': returnButton,
    },
};
</script>

<style scoped>
.main-container {
    padding-bottom: 40px;

}

.content-container {
    max-width: 80%;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
    min-height: 400px;
}

.content-container::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 400px;
    height: 400px;
    background-image: url('@/assets/medico-multicolores.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom right;

    z-index: -2;
    pointer-events: none;
}

.title-header {
    margin-bottom: 30px;
    text-align: center;
}

.title {
    color: white;
    font-size: 24px;
}

.content-container {
    /* max-width: 800px; */
    margin: 0 auto;
    padding: 0 20px;
}

.name-row {
    margin-bottom: 10px;
    /* flex-wrap: wrap; */
}

.data-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.data-item {
    display: flex;
    align-items: baseline;
}

.label {
    color: #00bfff;
    margin-right: 15px;
    position: relative;
    z-index: 2;
    font-family: 'Trebuchet MS';
    font-weight: bold;
}

.value {
    color: #333;
    padding-bottom: 3px;
    min-width: 200px;
    position: relative;
    z-index: 2;
    font-family: 'Trebuchet MS';
    background-color: rgba(255, 255, 255, 0.9);
}

.cedulas-container {
    display: grid;
    max-width: calc(100% - 400px);
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;

    margin: 20px 0;
}

.cedula-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@media (max-width: 1200px) {
    .cedulas-container {
        max-width: 100%; /* En pantallas pequeñas usamos todo el ancho */
    }
}


.cedula-info {
    margin-bottom: 8px;
}

.cedula-info:last-child {
    margin-bottom: 0;
}

.cedula-label {
    color: #00bfff;
    font-weight: bold;
    margin-right: 8px;
}

.cedula-value {
    color: #333;
}

@media (max-width: 600px) {
    .data-item {
        flex-direction: column;
    }

    .label {
        margin-bottom: 5px;
    }
}
</style>
